<!--
Author: TangChen
Date: 2018-10-31
Desc: 风险评测组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-risk-test bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">
                    个人中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <risk-ques />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import riskQues from "@/components/acctInfo/riskQues.vue";
export default {
    name: "RiskTest",
    components: {
        riskQues
    },
    mixins: [mixin],
    data () {
        return {
        };
    },
    methods: {}
};
</script>
<style lang="scss">
@import '../../assets/css/varibles';
.bizcomp-risk-test {
  padding-bottom: 36px;
}
</style>
